import AssetPreview from '../view-model/AssetPreview';
import { getLanguageCode } from './i18n/IntlContext';

const moneyFormat = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'BRL' });

const numberToMoney = (value: number, symbol: boolean = true) => {
    let formatted = moneyFormat.format(value);

    if (!symbol)
        formatted = formatted.replace('R$', '').trim();

    return formatted;
};

const moneyToInt = (value: number, fraction: number = 2) => Number(value.toFixed(fraction).split('.').join(''));

const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

const stringToDate = (value: string) => {
    if (!value || typeof value !== 'string')
        return null;

    const [dateString, monthString, yearString] = value.split('/');

    if (
        !dateString || dateString.length !== 2 ||
        !monthString || monthString.length !== 2 ||
        !yearString || yearString.length !== 4
    )
        return null;

    const [date, month, year] = [Number(dateString), Number(monthString), Number(yearString)];

    if (
        Number.isNaN(date) || date < 1 || date > 31 ||
        Number.isNaN(month) || month < 1 || month > 12 ||
        Number.isNaN(year) || year < 0
    )
        return null;

    if (month === 2)
        monthLength[1] = year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0) ? 29 : 28;

    if (date > monthLength[month - 1])
        return null;

    return new Date(year, month - 1, date);
}

type FormatStyle = 'full' | 'long' | 'medium' | 'short';

const dateToCustomFormatString = (date: Date, options?: Intl.DateTimeFormatOptions & { dateStyle?: FormatStyle, timeStyle?: FormatStyle }) =>
    new Intl.DateTimeFormat(getLanguageCode(), options).format(date);

const dateToDateTimeString = (date: Date) => date.toLocaleString(getLanguageCode());

const dateToDateString = (date: Date) => date.toLocaleDateString(getLanguageCode());

const dateToTimeString = (date: Date) => date.toLocaleTimeString(getLanguageCode());

const maskURL = (value: any) => value && typeof value === 'string' && !value.includes('://') ? `https://${value}` : value;

const getPreview = <T extends { preview: AssetPreview }>(asset: T, size: 'xs' | 'sm' | 'default' = 'default', webp = true) => {
    let preview;

    switch (size) {
        case 'xs':
            preview = asset.preview.xs ?? asset.preview.sm ?? asset.preview;
            break;

        case 'sm':
            preview = asset.preview.sm ?? asset.preview;
            break;

        default:
            preview = asset.preview;
            break;
    }

    return webp && preview.webpUrl ? preview.webpUrl : preview.url;
};

const formatters = { numberToMoney, moneyToInt, stringToDate, dateToCustomFormatString, dateToDateTimeString, dateToDateString, dateToTimeString, maskURL, getPreview };

export default formatters;
